<mat-drawer-container class="content-layout-container"
    [ngClass]="isViewInSmaller ? 'smallerscreen-menu': 'largerscreen-menu'" hasBackdrop="false" autosize>
    <mat-drawer #sideBarNavigation mode="push" class="sidenav" opened="true">
        <!-- sideNav component -->
        <!-- <app-sidebar [sideNav]="sideBarNavigation" [isViewInSmaller]="isViewInSmaller"  (istoggle)="sideBarMode=$event" [menuMode]="sideBarMode || 'standard'"></app-sidebar> -->
    </mat-drawer>

    <mat-drawer-content class="main-content">
        <!-- header component -->
        <app-header [sideNav]="sideBarNavigation" (istoggle)="sideBarMode=$event"></app-header>
        <app-top-navbar class="no-print" [sideNav]="sideBarNavigation" (istoggle)="sideBarMode=$event"></app-top-navbar>
        <div class="entry-point">
            <div class="page_bg">

                <div class="d-flex flex-column entry-container">
                    <!-- breadcrumb -->
                    <!-- page entry outlet-->
                    
                    <router-outlet></router-outlet>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </mat-drawer-content>
</mat-drawer-container>